import { HttpHeaders } from '@angular/common/http';
import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { NavigationExtras, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { TokenService } from 'src/app/shared/service/token.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-product-list',
  templateUrl: './product-list.component.html',
  styleUrls: ['./product-list.component.scss']
})
export class ProductListComponent implements OnInit {

  public menus = [];
  public selected = [];
  ProductList;
  isLoading;
  isDeleting;
  DeletingItem;

  constructor(private router: Router, private http: HttpClient, private toastr: ToastrService, private modalService: NgbModal, private TokenService: TokenService) {
    const a = JSON.parse(this.TokenService.getUser().Authority);
    if (!a['ProductList']) {
      router.navigateByUrl('/');
    }
  }


  ngOnInit() {
    this.GetProductList();
  }

  GetProductList() {
    this.http.get<any>(environment.url + 'Products/GetAllProducts?LangCode=tr').subscribe(data => {
      this.ProductList = data;
      this.isLoading = true;
    });
  }
  DeleteProduct() {
    this.isDeleting = true;
    var body = { StatusRef: this.DeletingItem };
    this.http.post<any>(environment.url + 'Product/RemoveProduct', body).subscribe(data => {
      this.isDeleting = false;
      this.DeletingItem = "";
      this.GetProductList();
      if (!data.Error) {
        this.modalService.dismissAll();
        this.toastr.success("Ulaşım Yolu Silindi", '', {
          timeOut: 3000,
        });
      }
      else {
        this.toastr.error("Ulaşım Yolu Silinemedi", 'Hata !', {
          timeOut: 3000,
        });
      }
    });
  }
  gotoProductEdit(item: any) {
    const navigatioExtra: NavigationExtras = {
      queryParams: { id: item }
    }
    this.router.navigate(['/home/definitions/edit-product'], navigatioExtra);
  }
  DeleteProductModal(file,ref) {
    this.DeletingItem = ref;
    this.modalService.open(file, { centered: true });
  }
  CloseDeleteModalClose(){
    this.modalService.dismissAll();
    this.DeletingItem = "";
  }
}
